import { Link } from "react-router-dom";

/**
 * Slide-down nav for mobile viewports (<768px). Rendered by the header when
 * the burger button is toggled. Two-column grid of pill links.
 */
export default function MobileNav({ items, open, onClose, activeCheck }) {
  if (!open) return null;
  return (
    <div className="md:hidden border-t border-[#2A2A2A] bg-black/95 backdrop-blur-xl">
      <div className="grid grid-cols-2 gap-px bg-[#2A2A2A]">
        {items.map((n) => (
          <Link
            key={n.key}
            to={n.to}
            data-testid={`m-nav-${n.key}`}
            onClick={onClose}
            className={`px-4 py-4 bg-black font-mono text-xs uppercase tracking-widest ${
              activeCheck(n.to)
                ? "text-[#FF4500]"
                : n.emphasize ? "text-[#FF4500]" : "text-gray-300"
            }`}
          >
            {n.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
